import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
  dialogClasses,
  paperClasses,
  styled,
} from "@mui/material";
import { JSXElementConstructor } from "react";

type KeyEditorActionModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  body: string;
  onCancel: () => void;
  buttonText: string;
  buttonAction: () => void;
  buttonEndIcon?: React.ReactNode;
  width?: string;
};

const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  color: theme.palette.text50.main,
  padding: "0 0 20px",
})) as typeof DialogTitle;

const DialogContentStyled = styled(DialogContent)(() => ({
  width: "100%",
  display: "grid",
  alignItems: "center",
  padding: "20px 0",
})) as typeof DialogContent;

const DialogActionsStyled = styled(DialogActions)(() => ({
  paddingTop: "12px",
})) as typeof DialogActions;

interface DialogStyledProps extends DialogProps {
  width?: string;
}

const DialogStyled = styled(Dialog)<DialogStyledProps>(({ width, theme }) => ({
  [`& .${dialogClasses.container}`]: {
    [`& .${paperClasses.root}`]: {
      width: width || "374px",
      borderRadius: "4px",
      backgroundColor: theme.palette.surfaceLight10,
      padding: "24px",
    },
  },
})) as JSXElementConstructor<DialogStyledProps>;

const KeyEditorActionModal = ({
  open,
  onClose,
  title,
  body,
  onCancel,
  buttonText,
  buttonAction,
  buttonEndIcon,
  width,
}: KeyEditorActionModalProps) => {
  return (
    <DialogStyled open={open} onClose={onClose} width={width}>
      <DialogTitleStyled>
        <Typography variant="heading.five">{title}</Typography>
      </DialogTitleStyled>
      <DialogContentStyled>
        <Typography variant="body.medium.regular">{body}</Typography>
      </DialogContentStyled>
      <DialogActionsStyled>
        <Button variant="text" size="small" color="secondary" onClick={onCancel} sx={{ padding: "8px 24px 8px 24px" }}>
          Cancel
        </Button>
        <Button
          endIcon={buttonEndIcon}
          color="secondary"
          size="small"
          onClick={buttonAction}
          sx={{ padding: "8px 24px 8px 24px" }}
        >
          {buttonText}
        </Button>
      </DialogActionsStyled>
    </DialogStyled>
  );
};

export { KeyEditorActionModal };
